/** @jsx jsx */
import * as React from 'react';
import * as classNames from 'classnames';
import { css } from '@emotion/core';
import { dodgerBlue40 } from '@ridi/colors';
import { jsx } from '@emotion/core';
import { isAnimationContent, LinkedContent } from 'app/pages/bookDetail/types';
import { useLinkedContentLink } from 'app/pages/bookDetail/hooks';
import { BookDetailContext } from 'app/pages/bookDetail/components/BookDetailContext';
import { LinkedContentsPopup } from 'app/pages/bookDetail/components/LinkedContentsPopup';
import { PopupHandle } from 'app/components/popup/Popup';

interface NoticeLinkedContentsItemProps {
  item: LinkedContent[];
}

export function NoticeLinkedContentsItem({ item: contents }: NoticeLinkedContentsItemProps) {
  const { bookId } = React.useContext(BookDetailContext);

  const contentsExceptMe = contents.filter(content =>
    isAnimationContent(content) || content.book_id !== `${bookId}`
  );

  if (contentsExceptMe.length === 0) {
    return null;
  }

  //@ts-ignore
  const { isMobile } = global.Ridi.globals;
  const anchorStyle = css`
    width: 100%;
    display: flex;
    background: transparent;
    justify-content: space-between;
    align-items: center;
    svg {
      padding-right: ${isMobile ? '0' : '9px'};
    }

    :hover {
      h5 {
        color: ${dodgerBlue40};
      }
    }
  `;

  const popupRef = React.useRef<PopupHandle>();

  if (contentsExceptMe.length >= 2) {
    return (
      <li className={classNames('BookDetailNotice_List_Item')}>
        <button css={anchorStyle} onClick={() => popupRef.current?.open?.()}>
          <div className="BookDetailNotice_List_Item_Title">이 작품 다양하게 즐기기</div>
          <span className="BookDetailNotice_List_Item_TipText">
            {contents.length} 작품
          </span>
        </button>

        <LinkedContentsPopup
          className={classNames('LinkedContentsPopup')}
          contents={contents}
          ref={popupRef}
        />
      </li>
    )
  }

  const [ firstContent ] = contentsExceptMe;
  const { link, target, onClick } = useLinkedContentLink(firstContent);

  return (
    <li className={classNames('BookDetailNotice_List_Item')}>
      <a css={anchorStyle} href={link} target={target} onClick={onClick}>
        <div className="BookDetailNotice_List_Item_Title">
          {
            isAnimationContent(firstContent) ?
            '라프텔에서 애니메이션으로 보기' :
            firstContent.extra_book_metadata.mapped_category.text
          }
        </div>
      </a>
    </li>
  );
};

export type { LinkedContent };



// WEBPACK FOOTER //
// ./pages/bookDetail/components/Notice/items/NoticeLinkedContentsItem.tsx